export enum ECDAdjustmentsErrorType {
  InvalidTimeEntry = 'Invalid Time Entry',
  CoHandlerError = 'CoHandlerError',
  InvoicePriceError = 'InvoicePriceError',
}
